// Bê từ finiva-admin settings/hooks/useSettings.ts. Sửa: chỉ còn tùy chọn hiển thị
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { settingsService } from '../services/settings.service'
import type { AccountPreferences } from '../types'

export const SETTINGS_KEYS = {
  preferences: ['settings', 'preferences'] as const,
}

const fail = () => toast.error('Lưu không được. Thay đổi vẫn còn trên màn hình, thử lại sau.')

/** Tùy chọn hiển thị — tải một lần (MainLayout chờ nó để bảng khởi tạo đúng mặc định) */
export const useAccountPreferences = (enabled = true) =>
  useQuery({
    queryKey: SETTINGS_KEYS.preferences,
    queryFn: settingsService.preferences,
    enabled,
    staleTime: Infinity,
    retry: false,
  })

export function useSaveAccountPreferences() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (p: AccountPreferences) => settingsService.savePreferences(p),
    onSuccess: (d) => {
      qc.setQueryData(SETTINGS_KEYS.preferences, d)
      toast.success('Đã lưu')
    },
    onError: fail,
  })
}
